import React from 'react'

import { Icon, ErrorOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

const iconSize = { height: '100px', width: '100px' }

function ErrorState({ error }) {
  return (
    <div className="viewer-overlay">
      <Icon svgComponent={ErrorOutlined} color="warning" size={iconSize} notSpaced />
      <span className="viewer-overlay__title">Failed to start</span>
      <p>{error}</p>
    </div>
  )
}

ErrorState.propTypes = {
  error: string.isRequired,
}

export default ErrorState
